import { useState } from "react";
import Button from "../../../Buttons/Button";
import ModalEditPlacementsMeta from "./ModalEditPlacementsMeta";
import {
  ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_FROM_IG_DIRECT_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
} from "../../../../utils/constants";
import EditLocationAltIcon from "@mui/icons-material/EditLocationAlt";

const EditPlacementsMeta = ({
  language,
  adID,
  adPathForm,
  adGroupPathForm,
  onCallbackSelect = () => {},
  disabled = false,
  destinationType = ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
}) => {
  const [modalEditPlacementsOpen, setModalEditPlacementsOpen] = useState(false);

  const isLeadFromIgDirect =
    destinationType ===
    ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_FROM_IG_DIRECT_OPTION;

  if (isLeadFromIgDirect) return null;
  return (
    <>
      {!disabled && (
        <Button
          type="button"
          color="secondary"
          sx={{
            width: "fit-content",
            minWidth: "fit-content",
          }}
          onClick={() => setModalEditPlacementsOpen(true)}
        >
          <EditLocationAltIcon />
        </Button>
      )}
      {modalEditPlacementsOpen && (
        <ModalEditPlacementsMeta
          modalOpen={modalEditPlacementsOpen}
          onCloseModal={() => setModalEditPlacementsOpen(false)}
          destinationType={destinationType}
          adID={adID}
          language={language}
          adPathForm={adPathForm}
          adGroupPathForm={adGroupPathForm}
          onCallbackSelect={onCallbackSelect}
        />
      )}
    </>
  );
};

export default EditPlacementsMeta;
